export const popupContainerMetaData = {
    enforceContainerChildLimitsByWidth: false,
    enforceContainerChildLimitsByHeight: false
}
